const storeDictIT = {
  store: "Negozio",
  storeSettings: "Impostazioni",
  storeOrders: "Ordini",
  storeSchedules: "Appuntamenti",
  storeSchedulesSubtitle: "Gestisci gli appuntamenti sincronizzati con Google Calendar",
  storeTotalOrders: "Totale ordini",
  storePendingOrders: "Ordini in sospeso",
  orderDetails: "Dettagli dell'ordine",
  storeOrderDetails: "Dettagli dell'ordine",
  storeProducts: "Prodotti",
  myStore: "Il mio negozio",
  storePanelTitle: "Pannello negozio",
  storePanelSubtitle: "Gestisci le operazioni del tuo negozio.",
  storeOperations: "Operazioni",
  storeRegisteredArticles: "Articoli registrati",
  storeRevenue: "Fatturato",
  storePendingOperations: "Operazioni in sospeso",
  sinceStart: "Dall'inizio",
  awaitingProcessing: "In attesa di elaborazione",
  latestOrders: "Ultimi ordini",
  allOrders: "Tutti gli ordini",
  newProduct: "Nuovo prodotto",
  settingsTabGeneral: "Generale",
  settingsTabLocationContact: "Posizione e contatti",
  settingsTabIntegrations: "Integrazioni",
  integrationsDisabled: "Disattivato",
  backToPage: "Torna alla pagina",
  newProductOverlayTitle: "Nuovo prodotto",
  stepGeneralInfo: "Informazioni generali",
  stepGeneralInfoSubtitle: "Aumenta le vendite con informazioni dettagliate sul prodotto",
  stepPriceDetails: "Dettagli prezzo",
  stepPriceDetailsTitle: "Aggiungi dettagli del prodotto",
  stepPriceDetailsSubtitle: "Aumenta le vendite con informazioni dettagliate sul prodotto",
  stepProductImage: "Immagine prodotto",
  stepStockAvailability: "Stock e disponibilità",
  stepSummary: "Riepilogo",
  next: "Avanti",
  previous: "Indietro",
  submitProduct: "Registra prodotto",
  cancel: "Annulla",
  filterByOrderId: "ID ordine",
  filterByDateRange: "Intervallo date",
  filterByStatus: "Stato",
  search: "Cerca",
  customer: "Cliente",
  product: "Prodotto",
  service: "Servizio",
  downloadable: "Scaricabile",
  integrationsComingSoon: "In arrivo",
  website: "Sito web",
  save: "Salva",
  logo: "Logo",
  storeSettingsLogoHelp:
    "Immagine mostrata come logo del tuo negozio. Consigliato: proporzione 4:1.",
  storeSettingsTitleHelp: "Nome mostrato del tuo negozio.",
  storeSettingsDescriptionHelp: "Breve descrizione del tuo negozio.",
  storeSettingsWebsiteHelp: "URL del sito del tuo negozio o azienda.",
  storeSettingsSocialHelp:
    "Solo nome utente o profilo (es.: miapagina per instagram.com/miapagina).",
  storeSettingsMinOrderHelp:
    "Valore minimo dell'ordine per applicare la regola di spedizione selezionata.",
  storeSettingsFreightValueHelp:
    "Valore o percentuale di sconto applicata quando la regola è soddisfatta.",
  storeSettingsClickToUpload: "Clicca per caricare",
  storeSettingsOrDragDrop: "oppure trascina e rilascia",
  storeSettingsLogoFormats: "PNG, JPG o WebP. Max 5 MB.",
  storeSettingsCategoriesHelp: "Categorie a cui appartiene il tuo negozio.",
  storeSettingsAtecoHelp: "Cerca e aggiungi codici ATECO per l'attività del tuo negozio.",
  storeSettingsStoreLinkHelp: "Solo lettere minuscole e numeri, fino a 20 caratteri. Lascia vuoto per non usare un link personalizzato.",
  storeSettingsStoreLinkPlaceholder: "ilmionegozio",
  storeSettingsCopyLink: "Copia link",
  storeSettingsLinkCopied: "Link copiato!",
  storeSettingsCopyLinkDisabled: "Salva il link personalizzato per poterlo copiare.",
  free: "Gratuito",
  productInfo: "Informazioni sul prodotto",
  editProduct: "Modifica prodotto",
  storeEditTabGeneral: "Dettagli generali",
  storeEditTabImages: "Immagini del prodotto",
  storeEditTabStock: "Stato stock",
  storeEditImagesHint: "Usa la scheda Dettagli generali per gestire le immagini.",
  storeEditStockHint: "Usa la scheda Dettagli generali per gestire stock e pubblicazione.",
  noProducts: "Nessun prodotto registrato.",
  errorLoadingProduct: "Errore nel caricamento del prodotto.",
  orderDetailsSubtitle: "Puoi monitorare e gestire i dettagli dell'ordine.",
  orderDetailsStep1Send: "Invia ordine",
  orderDetailsStep2Delivered: "Ordine consegnato",
  orderDetailsStep3Payment: "Ricevi pagamento",
  orderDetailsStep4Completed: "Acquisto completato",
  orderDetailsAlertToProcess:
    "Da elaborare. Hai ricevuto un nuovo ordine! Controlla la disponibilità dei prodotti e inizia la preparazione.",
  orderDetailsTransactionId: "ID transazione",
  orderDetailsSummaryPurchase: "Riepilogo acquisto",
  orderDetailsSubtotal: "Subtotale",
  orderDetailsCoupon: "Coupon",
  orderDetailsVat: "IVA",
  orderDetailsShippingCosts: "Spese di spedizione",
  orderDetailsTotal: "Totale",
  orderDetailsTotalReceived: "Totale ricevuto",
  orderDetailsCashback: "Cashback",
  orderDetailsPaymentMethod: "Metodo di pagamento",
  orderDetailsCreditCard: "Carta di credito",
  orderDetailsExtracredit: "Extracredit",
  orderDetailsBuyer: "Acquirente",
  orderDetailsContact: "Contatto",
  orderDetailsPhone: "Telefono",
  orderDetailsEmail: "E-mail",
  orderDetailsShippingData: "Dati di spedizione",
  orderDetailsStatusToProcess: "Da elaborare",
  orderDetailsStatusShipped: "Spedito",
  orderDetailsStatusDelivered: "Consegnato",
  orderDetailsCancelOrder: "Annulla ordine",
  orderDetailsSendProduct: "Invia prodotto",
  orderDetailsOrderConfirmed: "Ordine confermato",
  orderDetailsPaymentApproved: "Il pagamento è stato approvato.",
  orderDetailsProductInTransit: "Il prodotto è in transito.",
  orderDetailsProductDelivered: "Il prodotto è stato consegnato.",
  orderDetailsLoading: "Caricamento...",
  shippingIncluded: "Spedizione inclusa",
  notifyAllUsers: "Notifica tutti gli utenti",
  notifyMyEconomicCircle: "Notifica il mio cerchio economico",
  notifications: "Notifiche",
  fileForDownload: "File da scaricare",
  sampleFileOptional: "Anteprima / campione (opzionale)",
  downloadFileType: "Tipo di file",
  downloadTypeAudio: "Audio",
  downloadTypeVideo: "Video",
  downloadTypeImage: "Immagine",
  downloadTypeDocument: "Documento",
  publishProductNow: "Pubblica prodotto subito",
  uploadZoneInstruction: "Scegli un file o trascinalo qui.",
  uploadZoneFormatsImages: "Formati JPEG, PNG e MP4, fino a 50 MB.",
  uploadZoneFormatsFile: "Tutti i formati, fino a 100 MB.",
  browseFiles: "Sfoglia file",
  primaryImage: "Primario",
  activate: "Attiva",
  confirmCode: "Conferma codice",
  whatsappDisconnected: "WhatsApp disconnesso",
  whatsappHasBeenDisconnected: "WhatsApp è stato disconnesso con successo.",
  errorDisconnectingWhatsApp: "Errore durante la disconnessione di WhatsApp. Per favore, riprova.",
  activated: "Attivato",
  deactivated: "Disattivato",
  removeIntegration: "Rimuovi integrazione",
  confirmRemoveIntegration:
    "Sei sicuro di voler rimuovere questa integrazione? Questa azione non può essere annullata.",
  confirmation: "Conferma",
  yes: "Sì",
  no: "No",
  googleCalendar: "Google Calendar",
  googleCalendarDescription: "Sincronizza i tuoi eventi e appuntamenti con Google Calendar",
  apiKey: "Chiave API",
  clientId: "ID Cliente",
  clientSecret: "Segreto Cliente",
  configure: "Configura",
  integrationsDescription:
    "Collega il tuo negozio con strumenti esterni per ottimizzare il tuo flusso di lavoro",
  whatsappIntegrationDescription:
    "Collega il tuo negozio a WhatsApp per il servizio clienti diretto",
  phoneNumber: "Numero di telefono",
  phoneNumber1: "Numero di telefono",
  enterYourPhoneNumber: "Inserisci il tuo numero di telefono",
  attention: "Attenzione",
  pleaseProvidePhoneNumber: "Si prega di fornire un numero di telefono",
  codeSent: "Codice inviato",
  confirmationCodeSentToWhatsApp: "Codice di conferma inviato a WhatsApp",
  error: "Errore",
  errorConnectingToServer: "Errore di connessione al server",
  pleaseProvideConfirmationCode: "Si prega di fornire il codice di conferma",
  success: "Successo",
  whatsappConfiguredSuccessfully: "WhatsApp configurato con successo",
  invalidConfirmationCode: "Codice di conferma non valido",
  configurationSavedSuccessfully: "Configurazione salvata con successo",
  goBackAndResendCode: "Torna indietro e reinvia il codice",
  confirmationCode: "Codice di conferma",
  enterReceivedCode: "Inserisci il codice ricevuto",
  integrationData: "Dati di integrazione",
  redirectedToGoogleAuth:
    "Reindirizzato all'autenticazione di Google. Completa il processo nella nuova scheda.",
  errorGettingAuthUrl: "Errore nell'ottenere l'URL di autenticazione",
  googleCalendarDisconnected: "Google Calendar disconnesso",
  googleCalendarHasBeenDisconnected: "Google Calendar è stato disconnesso con successo.",
  errorDisconnectingGoogleCalendar:
    "Errore durante la disconnessione di Google Calendar. Per favore, riprova.",
  noSchedulesYet: "Nessun appuntamento ancora",
  scheduleConnectGoogleCalendar:
    "Collega Google Calendar nella scheda integrazioni per sincronizzare i tuoi appuntamenti",
  confirmed: "Confermato",
  pending: "In attesa",
  manageOrders: "Gestisci i tuoi ordini",
  manageProducts: "Gestisci i tuoi prodotti",
  manageSchedules: "Gestisci i tuoi appuntamenti",
  viewSchedules: "Visualizza appuntamenti",
  scheduleSetupTitle: "Configurazione iniziale richiesta",
  scheduleSetupDescription: "Per utilizzare il sistema di appuntamenti, segui i passaggi seguenti:",
  scheduleStep1Title: "Connetti Google Calendar",
  scheduleStep1Description:
    "Connetti il tuo account Google Calendar per sincronizzare gli appuntamenti",
  scheduleStep1Connected: "Google Calendar connesso con successo",
  scheduleStep2Title: "Configura preferenze orario",
  scheduleStep2Description:
    "Definisci i giorni e gli orari in cui i clienti possono prenotare i tuoi servizi.",
  scheduleStep2Configured: "Preferenze orario configurate",
  connect: "Connetti",
  integrationComplete: "Integrazione completata!",
  yourAccountIsNowConnected: "Il tuo account ora è connesso.",
  whatsappBotReady: "Il bot di WhatsApp è pronto per leggere la tua agenda.",
  integrationIncomplete: "Integrazione incompleta",
  youNeedToCompleteTheFollowingSteps: "Devi completare i seguenti passaggi.",
  standardAppointmentLength: "Durata standard dell'appuntamento",
  scheduleBufferLabel: "Buffer tra appuntamenti (min)",
  scheduleBufferHelp: "Pausa tra un appuntamento e l'altro",
  scheduleAppointmentLengthHelp: "Durata predefinita dell'appuntamento",
  scheduleWorkStartLabel: "Inizio orario di lavoro",
  scheduleWorkEndLabel: "Fine orario di lavoro",
  scheduleSelectDays: "Seleziona i giorni lavorativi",
  scheduleClientInstructionsLabel: "Istruzioni per il cliente",
  scheduleClientInstructionsPlaceholder: "Es.: arriva in loco 15 minuti prima dell'appuntamento.",
  scheduleClientInstructionsHelp:
    "Queste istruzioni verranno inviate al cliente alla conferma della prenotazione.",
  monday: "Lunedì",
  tuesday: "Martedì",
  wednesday: "Mercoledì",
  thursday: "Giovedì",
  friday: "Venerdì",
  saturday: "Sabato",
  sunday: "Domenica",
  openYourGoogleCalendar: "Visualizza su Google Calendar",
  availability: "Disponibilità",
  scheduleStep3Title: "Appuntamenti e prenotazioni",
  scheduleStep3Description:
    "Gestisci appuntamenti e richieste di supporto direttamente dalla tua agenda.",
  configureYourAvailability: "Configura la tua disponibilità",
  defineDaysAndTimes:
    "Definisci i giorni e gli orari in cui i clienti possono prenotare i tuoi servizi",
  removeWhatsAppIntegration: "Rimuovere l'integrazione con WhatsApp?",
  removeWhatsAppIntegrationDescription:
    "Il numero di telefono verrà eliminato dai nostri sistemi e il pulsante di contatto non sarà più visibile ai clienti del tuo negozio. Puoi riattivare il servizio in qualsiasi momento.",
  removeGoogleCalendarIntegration: "Rimuovere l'integrazione con Google Calendar?",
  removeGoogleCalendarIntegrationDescription:
    "La connessione a Google Calendar verrà rimossa e i tuoi appuntamenti non saranno più sincronizzati. Puoi riattivare il servizio in qualsiasi momento.",
  remove: "Rimuovi",
  physicalStore: "Convenzione",
  physicalStoreConventionTitle: "Convenzione Negozio Fisico",
  physicalStoreConventionSubtitle:
    "Leggi e firma la convenzione per attivare il tuo negozio fisico e iniziare a ricevere pagamenti.",
  physicalStoreConventionAlreadySigned: "Convenzione già firmata",
  physicalStoreConventionAlreadySignedDesc: "Hai già firmato la convenzione per il negozio fisico. Non sono necessarie ulteriori azioni.",
  physicalStoreConventionAccept: "Ho letto e accetto i termini della convenzione",
  physicalStoreConventionConfirm: "Conferma e firma",
  physicalStoreConventionSignedSuccess: "Convenzione firmata con successo!",
  physicalStoreConventionSignedError: "Errore nella firma della convenzione. Riprova.",
  physicalStoreConventionLoading: "Caricamento convenzione...",
  physicalStoreConventionCommercialName: "Nome commerciale",
  physicalStoreConventionCompanyName: "Ragione sociale",
  physicalStoreConventionAddress: "Indirizzo",
  physicalStoreConventionNumber: "Numero",
  physicalStoreConventionCity: "Città",
  physicalStoreConventionPostalCode: "CAP",
  physicalStoreConventionProvince: "Provincia",
  physicalStoreConventionPhone: "Telefono",
  physicalStoreConventionProofPhoto: "Foto dell'esercizio",
  physicalStoreConventionProofPhotoPlaceholder: "Clicca per selezionare un'immagine",
  physicalStoreConventionUploading: "Caricamento...",
  physicalStoreConventionPendingTitle: "Prova in revisione",
  physicalStoreConventionPendingMessage: "La tua prova è stata inviata ed è in attesa di revisione. Presto potrai utilizzare il negozio fisico.",
  physicalStoreConventionRejectedTitle: "Prova rifiutata",
  physicalStoreConventionApprovedTitle: "Negozio fisico approvato",
  physicalStoreConventionApprovedMessage: "Il tuo negozio fisico è stato approvato. Puoi ora utilizzare tutte le funzionalità di pagamento fisico.",
  physicalStoreConventionLegalRepresentative: "Nome del rappresentante legale",
  physicalStoreConventionTaxId: "Codice fiscale / P.IVA",
  physicalStoreConventionMerchantCategory: "Categoria merceologica",
  physicalStoreConventionViewDoc: "Visualizza i termini della convenzione",
  physicalStoreNewPayment: "Nuovo pagamento",
  physicalStoreNewPaymentDesc: "Crea un nuovo addebito con QR Code",
  physicalStorePaymentsList: "Storico pagamenti",
  physicalStorePaymentsListDesc: "Visualizza tutti i pagamenti ricevuti",
  physicalStoreCameraPayment: "Paga con la fotocamera",
  physicalStoreCameraPaymentDesc: "Scansiona il QR Code per incassare",
  physicalStoreVerificationTitle: "Verifica del negozio fisico",
  physicalStoreVerificationSubtitle: "Invia una prova per abilitare gli addebiti",
  physicalStoreVerificationPendingSubtitle: "La tua prova è in fase di revisione",
  physicalStoreVerificationPendingMessage:
    "La tua prova è stata inviata ed è in attesa di revisione. Presto potrai creare addebiti.",
  physicalStoreVerificationRejected: "Prova rifiutata",
  physicalStoreVerificationAddressPlaceholder: "Via / Viale",
  physicalStoreVerificationNumberPlaceholder: "N.",
  physicalStoreVerificationPostalCodePlaceholder: "00000-000",
  physicalStoreVerificationStatePlaceholder: "Provincia",
  addProduct: "Aggiungi prodotto",
  searchProductByName: "Cerca per nome del prodotto",
  productsViewGrid: "Visualizzazione a griglia",
  productsViewList: "Visualizzazione a elenco",
  productListValue: "Valore",
  productListRegistration: "Registrazione",
  sortBy: "Ordina",
  sortMostRecent: "Più recente",
  sortOldest: "Più vecchio",
  sortHighestValue: "Valore più alto",
  unpublishProduct: "Annulla pubblicazione",
  publishProduct: "Pubblica prodotto",
  notifyUsers: "Notifica utenti",
  notifyEconomicCircle: "Notifica cerchio economico",
  productTypeModalTitle: "Che tipo di prodotto o servizio vuoi registrare?",
  productTypePhysical: "Prodotto fisico",
  productTypePhysicalDesc: "Prodotti che verranno consegnati ai clienti.",
  productTypeService: "Servizio",
  productTypeServiceDesc: "Servizio che offri ai clienti.",
  productTypeDigital: "Prodotto digitale",
  productTypeDigitalDesc: "I clienti potranno scaricare il tuo prodotto.",
  addProductDetails: "Aggiungi i dettagli del prodotto",
  addProductDetailsSubtitle: "Descrivi i dettagli del prodotto per la visualizzazione.",
  addServiceDetails: "Aggiungi i dettagli del servizio",
  addServiceDetailsSubtitle: "Descrivi i dettagli del servizio per la visualizzazione.",
  productName: "Nome del prodotto",
  productNamePlaceholder: "Inserisci il nome del prodotto",
  serviceNamePlaceholder: "Inserisci il nome del servizio",
  productState: "Stato del prodotto",
  productStateNew: "Nuovo",
  productStateUsed: "Usato",
  withVariation: "Con variazione?",
  withVariationHelp: "Ideale per articoli con taglie o colori diversi.",
  forSale: "In vendita",
  forSaleHelp: "Pubblica per la visualizzazione immediata.",
  fullDescription: "Descrizione completa",
  fullDescriptionPlaceholder: "Inserisci una descrizione completa del prodotto.",
  fullDescriptionPlaceholderService: "Inserisci una descrizione completa del servizio.",
  fullDescriptionTip: "Cura la descrizione dettagliata",
  stock: "Scorte",
  stockPlaceholder: "Es.: 10",
  category: "Categoria",
  subcategory: "Sottocategoria",
  selectCategory: "Seleziona una categoria",
  selectSubcategory: "Seleziona una sottocategoria",
  selectFileType: "Seleziona un tipo di file",
  requiredFieldsHint: "* campi obbligatori per pubblicare",
  productCharacteristics: "Caratteristiche del prodotto",
  productCharacteristicsSubtitle:
    "Organizza le informazioni in gruppi. In ogni gruppo, aggiungi un titolo e le coppie di informazioni che appariranno nella scheda delle caratteristiche.",
  serviceCharacteristics: "Caratteristiche del servizio",
  serviceCharacteristicsSubtitle:
    "Organizza le informazioni in gruppi. In ogni gruppo, aggiungi un titolo e le coppie di informazioni che appariranno nella scheda delle caratteristiche del servizio.",
  noCharacteristics: "Nessuna caratteristica registrata.",
  createCharacteristics: "Crea caratteristiche per il mio prodotto",
  createCharacteristicsService: "Crea caratteristiche per il mio servizio",
  characteristicsFooter: "Questo contenuto apparirà nella scheda Caratteristiche del prodotto.",
  characteristicsFooterService: "Questo contenuto apparirà nella scheda Caratteristiche del servizio.",
  addGroup: "Aggiungi gruppo",
  addItem: "Aggiungi elemento",
  characteristicTitle: "Titolo",
  characteristicDescription: "Descrizione",
  groupNamePlaceholder: "Digita il nome del gruppo",
  characteristicTitlePlaceholder: "Es: Materiale",
  characteristicDescriptionPlaceholder: "Es: Cotone premium",
  saveCharacteristicGroup: "Salva",
  removeCharacteristicGroup: "Rimuovi gruppo",
  characteristicGroupItem: "{count} elemento",
  characteristicGroupItems: "{count} elementi",
  unnamedCharacteristicGroup: "Caratteristiche",
  priceDetails: "Definisci i dettagli del prezzo",
  priceDetailsSubtitle: "Quanto costerà il prodotto, quali sconti e cashback verranno applicati.",
  priceDetailsSubtitleService:
    "Quanto costerà il servizio, quali sconti e cashback verranno applicati.",
  discountAndShippingDetails: "Definisci sconti e spedizione",
  discountAndShippingSubtitle:
    "Tipo di spedizione, misure del prodotto, sconti e cashback da applicare.",
  priceHelp: "Definisci quanto vuoi ricevere per il prodotto.",
  priceHelpService: "Definisci quanto vuoi ricevere per il servizio.",
  discountOptional: "Sconto (Opzionale)",
  discountHelp: "Mostra che il prodotto è in sconto.",
  discountHelpService: "Mostra che il servizio è in sconto.",
  cashbackPercent: "Percentuale di Cashback",
  cashbackHelpPrefix: "Per capire come viene calcolato il prezzo finale, visita la nostra",
  priceCalculator: "calcolatrice dei prezzi",
  productDimensions: "Inserisci le dimensioni del prodotto",
  productDimensionsSubtitle: "Le misure vengono usate per calcolare la spedizione.",
  heightCm: "Altezza (cm)",
  widthCm: "Larghezza (cm)",
  lengthCm: "Lunghezza (cm)",
  weightKg: "Peso (kg)",
  shipping: "Spedizione",
  shippingHelp: "Come preferisci che la spedizione sia gestita per il tuo prodotto.",
  shippingSimulator: "Simulatore di spedizione",
  breadcrumbsAriaLabel: "Percorso di navigazione",
  freeShipping: "Spedizione gratuita",
  freeShippingDesc: "Il negozio è responsabile dei costi di spedizione.",
  paidShipping: "Spedizione a pagamento",
  paidShippingDesc: "Il cliente paga la spedizione al checkout.",
  localPickup: "Ritiro in negozio",
  localPickupDesc: "Il cliente potrà ritirare l'ordine in negozio.",
  productVariations: "Variazioni del prodotto",
  productVariationsSubtitle:
    "Puoi scegliere fino a 2 attributi e fino a 5 variazioni per ogni prodotto.",
  addVariationOptions: "Aggiungi opzioni come colore o taglia.",
  addAnotherOption: "Aggiungi un'altra opzione",
  optionName: "Nome dell'opzione",
  optionValues: "Valori dell'opzione",
  addValue: "Aggiungi valore",
  done: "Fatto",
  variant: "Variante",
  variantPrice: "Prezzo",
  variantStock: "Scorte",
  selectImage: "Seleziona immagine",
  uploadedImages: "Immagini caricate",
  addFiles: "Aggiungi file",
  confirm: "Conferma",
  addProductImages: "Aggiungi le immagini del prodotto",
  addProductImagesSubtitle:
    "Usa foto da angolazioni diverse per offrire una migliore esperienza al cliente.",
  addServiceImages: "Aggiungi le immagini del servizio",
  addServiceImagesSubtitle:
    "Usa foto da angolazioni diverse per offrire una migliore esperienza al cliente.",
  uploadFiles: "Carica file",
  uploadZoneFormatsProductImages: "Formati JPEG, PNG e WEBP. Fino a 5 MB.",
  digitalProductFiles: "File del prodotto digitale",
  digitalProductFilesSubtitle: "Carica la copertina, il file principale e un campione opzionale.",
  coverImage: "Immagine di copertina",
  coverImageHelp: "Immagine visualizzata nel negozio.",
  coverImageFormats: "Formati accettati: JPG, PNG e WebP.",
  coverImageSize: "Dimensione massima: 3MB.",
  mainProductFile: "File principale del prodotto",
  mainProductFileHelp: "File che il cliente riceve dopo l'acquisto.",
  mainProductFileFormats: "Formati accettati: Tutti i formati.",
  mainProductFileSize: "Dimensione massima: 100MB.",
  previewSample: "Campione di anteprima (opzionale)",
  previewSampleHelp: "Una versione demo o ridotta del prodotto.",
  previewSampleFormats: "Formati accettati: Tutti i formati.",
  previewSampleSize: "Dimensione massima: 100MB.",
  selectFiles: "Seleziona file",
  replaceFile: "Sostituisci file",
  viewFile: "Visualizza",
  uploadedSuccessfully: "Caricato con successo",
  requiredFilesToPublish: "I file obbligatori devono essere inviati per pubblicare il prodotto.",
  dragDropOrSelect: "Trascina e rilascia qui",
  uploadZoneHelp: "o seleziona un file dal computer.",
  register: "Registra",
  noProductsFound: "Nessun prodotto trovato.",
  notifyConfirmUsers: "Vuoi notificare tutti gli utenti su questo prodotto?",
  notifyConfirmCircle: "Vuoi notificare il tuo cerchio economico su questo prodotto?",
  notifyInsufficientBalance: "Saldo ExtraBonus insufficiente per inviare la notifica.",
  productPublished: "Prodotto pubblicato con successo.",
  productUnpublished: "Pubblicazione del prodotto annullata.",
  productNotified: "Notifica inviata con successo.",
  examplePlaceholder: "Es.:",
};

export default storeDictIT;
